import * as React from 'react';
import { connect } from 'react-redux';
import { actions } from 'react-redux-form';
import { Form } from '../';
import FIELDS from '../../data/fields';

interface Props {
  booking: any;
  handleUpdate: Function;
  handleError?: Function;
  updateOnChange: boolean;
  isDisabled: boolean;
  fields?: any;
}

class BookingUpdatePricingForm extends React.Component<Props> {
  /**
   * Handle field validation
   * @param {Object} data
   * @return {Object|Boolean}
   */
  handleValidate(data): any {
    return {
      security_cost: Number(data.security_cost),
      discount: Number(data.discount),
      discount_note: data.discount_note,
      responsibility_amount: Number(data.responsibility_amount),
      order_number: data.order_number,
      hire_cost_per_day: data.hire_cost_per_day,
      additional_driver_cost: data.additional_driver_cost,
    };
  }

  render() {
    const handleChange = (data) => {
      const validatedData = this.handleValidate(data);
      if (this.props.handleError !== undefined) {
        this.props.handleError(validatedData === false);
      }
      if (validatedData !== false) {
        this.props.handleUpdate(validatedData);
      }
    };
    return (
      <div className="field">
        <Form
          fields={
            this.props.fields
              ? this.props.fields
              : FIELDS.bookings.updatePricing
          }
          type="pricing"
          buttonText="Apply"
          handleSubmit={handleChange}
          hasButton={!this.props.updateOnChange}
          handleChange={(data) => {
            if (this.props.updateOnChange) {
              handleChange(data);
            }
          }}
          disabled={this.props.isDisabled}
          // Handle default value population
          getDispatch={(dispatch) => {
            const booking = this.props.booking;
            dispatch(
              actions.change(
                'pricing.security_cost',
                booking.security_cost || '0',
              ),
            );
            dispatch(
              actions.change('pricing.discount', booking.discount || '0'),
            );
            dispatch(
              actions.change(
                'pricing.discount_note',
                booking.discount_note || '',
              ),
            );
            dispatch(
              actions.change(
                'pricing.order_number',
                booking.order_number !== 'null' ? booking.order_number : '',
              ),
            );
            [
              'responsibility_amount',
              'hire_cost_per_day',
              'additional_driver_cost',
            ].map((field) =>
              dispatch(actions.change(`pricing.${field}`, booking[field] || 0)),
            );
          }}
        />
      </div>
    );
  }
}

export default connect()(BookingUpdatePricingForm);
